$.fn.modal = function(action, options) {
  return this.each(function() {
    const element = this;
    let modal = bootstrap.Modal.getInstance(element);

    if (!modal) {
      const config = typeof action === 'object' ? action : (options || {});
      modal = new bootstrap.Modal(element, config);
    }

    if (typeof action === 'string') {
      modal[action]();
    } else if (action === undefined || typeof action === 'object') {
      modal.show();
    }
  });
};